import { useCurrentScreen } from '../hooks/screen/useCurrentScreen';
import { useAuthGuard } from '../hooks/auth/useAuthGuard';
import { useOnboardingGuard } from '../hooks/auth/useOnboardingGuard';
import { useSocketConnection } from '../hooks/socket/useSocketConnection';
import { useClientsChannel } from '../hooks/clients/useClientsChannel';
import { useVehiclesChannel } from '../hooks/vehicles/useVehiclesChannel';
import { useDriversChannel } from '../hooks/drivers/useDriversChannel';
import { useTurnosChannel } from '../hooks/turnos/useTurnosChannel';
import { useLinesChannel } from '../hooks/lines/useLinesChannel';
import { useMapChannel } from '../hooks/map/useMapChannel';
import { useFiltersBootstrap } from '../hooks/filters/useFiltersBootstrap';
import { useFiltersChannel } from '../hooks/filters/useFiltersChannel';
import { useScreenSocket } from '../hooks/screen/useScreenSocket';
import { useScreenStore } from '../stores/useScreenStore';
import { useTripsChannel } from '../hooks/trips/useTripsChannel';
import { useTripsFiltersChannel } from '../hooks/trips/useTripsFiltersChannel';
import { useHourRangeChannel } from '../hooks/hourRange/useHourRangeChannel';
import { useOperationalMapModeChannel } from '../hooks/operationalMapMode/useOperationalMapModeChannel';
import { usePontosItinerarioChannel } from '../hooks/pontos/usePontosItinerarioChannel';
import { useLoadingChannel } from '../hooks/loading/useLoadingChannel';
import { useChegadasViagensSocket } from '../hooks/chegadasViagens/useChegadasViagensSocket';
import { useSchedulesSocket } from '../hooks/schedules/useSchedulesSocket';
import { usePontosOperacionaisSocket } from '../hooks/pontosOperacionais/usePontosOperacionaisSocket';
import { useTripAlertsAnalysisChannel } from '../hooks/analysis/useTripAlertsAnalysisChannel';
import { useTripStatusAnalysisChannel } from '../hooks/analysis/useTripStatusAnalysisChannel';
import { useTripPositionsAnalysisChannel } from '../hooks/analysis/useTripPositionsAnalysisChannel';
import { useTripOccurrencesChannel } from '../hooks/trips/useTripOccurrencesChannel';
import { useTripVehiclesChangesChannel } from '../hooks/trips/useTripVehiclesChangesChannel';
import useOperationalRangeWatcher from '../hooks/hourRange/useOperationalRangeWatcher';
import TopAlerts from '../components/hashs/TopAlerts';

const Filters = () => {
  
  const screenBlocked  = useScreenStore(state => state.screenBlocked);

  useCurrentScreen('Filtros');
  const { hasUser } = useAuthGuard();
  const { canRender, isDualMonitor } = useOnboardingGuard('filters');
  useLoadingChannel();
  useSocketConnection();
  useScreenSocket();
  useClientsChannel();
  useVehiclesChannel();
  useDriversChannel();
  useTurnosChannel();
  useLinesChannel();
  useTripsChannel();
  useTripsFiltersChannel();
  useFiltersBootstrap();
  useFiltersChannel();
  useMapChannel();
  useHourRangeChannel();
  usePontosItinerarioChannel();
  useChegadasViagensSocket();
  useSchedulesSocket();
  useTripAlertsAnalysisChannel();
  useTripStatusAnalysisChannel();
  useTripPositionsAnalysisChannel();
  useOperationalMapModeChannel();
  useTripOccurrencesChannel();
  useTripVehiclesChangesChannel();
  useOperationalRangeWatcher();
  usePontosOperacionaisSocket();

  if(!hasUser || !canRender || !isDualMonitor | screenBlocked) return null;

  return (
    <>
      <TopAlerts/>
    </>
  );
};

export default Filters;